import { lazy } from 'react';

// 使用懒加载导入所有页面组件
const Index = lazy(() => import('../pages/index/index'));
const Sustainable = lazy(() => import('../pages/Sustainable'));
const CaseStudies = lazy(() => import('../pages/CaseStudies'));
const News = lazy(() => import('../pages/News'));
const Future = lazy(() => import('../pages/Future'));
const Business = lazy(() => import('../pages/Business'));
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
const Terms = lazy(() => import('../pages/Terms'));



// 路由配置
const routes = [
  {
    path: '/',
    key: 'index',
    element: <Index />,
    exact: true,
  },//home
  {
    path: '/sustainable',
    key: 'sustainable',
    element: <Sustainable />,
  },//Sustainable Development
  {
    path: '/cases',
    key: 'cases',
    element: <CaseStudies/>,
  },//Case Studies
  {
    path: '/news',
    key: 'news',
    element: <News/>,
  },//News
  {
    path: '/future',
    key: 'future',
    element: <Future />,
  },//Future
  {
    path: '/business',
    key: 'business',
    element: <Business />,
  },//Business
  {
    path: '/privacy-policy',
    key: 'privacy-policy',
    element: <PrivacyPolicy />,
  },//Privacy Policy
  {
    path: '/terms',
    key: 'terms',
    element: <Terms />,
  },//Terms of Service


];

export default routes;